// Vue
import { Component, Vue } from "vue-property-decorator";
// Mobx
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
import { ModuleList } from "#/components/module_list/ModuleList";
import { autorun } from "mobx";
import { PageState } from "../../store/states/PageState";
import VueMatomo from "vue-matomo";
import { scrollToElementId } from "#/common/Utils";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleList,
  },
})
export default class Page extends Vue {
  private pageLayout: string | null = null;

  public created() {
    autorun(() => {
      if (this.pageLayout != this.$store.page.layoutComponent) {
        this.pageLayout = this.$store.page.layoutComponent;
      }
    });
  }

  public mounted() {
    this.refreshPage();

    if (this.$store.page.isInEditMode) {
      window.addEventListener("message", this.onMessage);
      window.addEventListener("beforeunload", this.onBeforeUnload);

      this.sendToParent({ type: "Cms.ContentReady" });
    }

    window.addEventListener("hashchange", this.onHashChange);
  }

  public beforeDestory() {
    if (this.$store.page.isInEditMode) {
      window.removeEventListener("message", this.onMessage);
      window.removeEventListener("beforeunload", this.onBeforeUnload);
    }

    window.removeEventListener("hashchange", this.onHashChange);
  }

  private onHashChange(event) {
    let hash = window.location.hash.substr(1);
    scrollToElementId(hash);
  }

  private sendToParent(message) {
    window.parent.window.postMessage(
      JSON.stringify(message),
      window.CMS_DOMAIN
    );
  }

  private onMessage = (event) => {
    if (event && event.data && typeof event.data === "string") {
      var data = JSON.parse(event.data);

      if (data.type === "Cms.Widget.Deleted") {
        this.refreshPage();
      } else if (data.type === "Cms.Widget.Added") {
        this.refreshPage();
      } else if (data.type === "Cms.Widget.Updated") {
        this.refreshPage();
      } else if (data.type === "Cms.Widget.Moved.Up") {
        this.refreshPage();
      } else if (data.type === "Cms.Widget.Moved.Down") {
        this.refreshPage();
      } else if (data.type === "Cms.Widget.Moved.Down") {
        this.refreshPage();
      } else if (data.type === "Cms.Widget.UpdatedTranslationStatus") {
        this.refreshPage();
      } else if (data.type === "Cms.Widget.Permissions") {
        this.$store.page.setEditPermission(data.permissions);
      }
    }
  };

  private onBeforeUnload = (event) => {
    this.sendToParent({ type: "Cms.Unload" });
  };

  public handleAddBelow() {
    if (this.$store.page.page) {
      let data = {
        type: "Cms.Widget.Add",
        pageId: this.$store.page.page.id,
      };

      if (
        this.$store.page.pageModules &&
        this.$store.page.pageModules.length > 0
      ) {
        data["after"] =
          this.$store.page.pageModules[
            this.$store.page.pageModules.length - 1
          ].id;
      }

      this.sendToParent(data);

      return true;
    } else {
      return false;
    }
  }

  private refreshPage() {
    let url = window.location.href;

    if (process.env.NODE_ENV !== "production") {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("forceUrl")) {
        url = urlParams.get("forceUrl")!;
      }
    }

    this.$store.ui.isLoadingAuto = true;
    this.$store.ui.isLoading = true;
    this.$store.page.getPage(url, this.$store.page.isInEditMode).then(() => {
      this.$store.ui.isLoading = false;

      if (this.$store.page.portalPiwikId) {
        Vue.use(VueMatomo, {
          host: "https://bb-portal.mercedes-benz-trucks.com/analytics",
          siteId: this.$store.page.portalPiwikId,
          trackPageView: true,
          enableLinkTracking: true,
          requireConsent: true,
          trackVisibleContentImpressions: true,
          router: this.$router,
          trackInitialView: true,
        });
      }

      setTimeout(() => {
        let hash = window.location.hash.substr(1);

        if (hash) {
          scrollToElementId(hash);
        }

        // In case this is rendered in an Iframe, we send our current height
        // to the parent window.
        if (
          window.parent &&
          window.parent.window &&
          window.parent.window.postMessage
        ) {
          var html = window.document.documentElement;
          var body = window.document.body;
          var height =
            Math.max(
              body.scrollHeight,
              body.offsetHeight,
              html.clientHeight,
              html.scrollHeight,
              html.offsetHeight
            ) + 4;

          window.parent.window.postMessage(
            JSON.stringify({ type: "iframeHeight", height: height }),
            window.location.protocol + "//" + window.location.host
          );
        }
      }, 1000);
    });
  }

  get layout() {
    if (this.pageLayout) {
      if (this.pageLayout in this.$options.components!) {
        return this.pageLayout;
      } else {
        return "ModuleDefaultLayout";
      }
    } else {
      return "ModuleLoadingLayout";
    }
  }
}
